import { cn } from './cn';

/**
 * Small rotating ring; a status named by `label` when given. `decorative`: no status of its own, for a spinner whose
 * surroundings already say what is happening (WaitingScreen). `os-spin` keeps it alive when motion is off or reduced:
 * it pulses in opacity instead of freezing, which would read as a hang (globals.css).
 */
export function Spinner({ label, className, decorative }: { label?: string; className?: string; decorative?: boolean }) {
  return (
    <span {...(decorative ? { 'aria-hidden': true } : { role: 'status', 'aria-label': label })} className={cn('inline-flex', className)}>
      <svg viewBox="0 0 16 16" className="os-spin h-4 w-4 animate-spin" aria-hidden="true">
        <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
        <path d="M14 8a6 6 0 00-6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </span>
  );
}
